import { render, staticRenderFns } from "./flat_buttons.vue?vue&type=template&id=26f61396&"
import script from "./flat_buttons.vue?vue&type=script&lang=js&"
export * from "./flat_buttons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports